'use strict';

// eslint-disable-next-line max-lines-per-function, max-params
angular.module('webAgro1App').factory('PendenciasService', function($http, $q, TarefaObjectService) {
  const tipoRecomendacao = {
    recomendacao_defensivo: () => (
      {
        descricao: 'Recomendação de Defensivos',
        tipo: 'recomendacao_defensivo',
        icon: 'icon-recomendation'
      }
    ),
    aqila_recomendacao: (recomendacao) => {
      if (recomendacao.operacao === 11) {
        return {
          descricao: 'Correção de Solo',
          tipo: 'recomendacao_defensivo',
          icon: 'icon-recomendation'
        };
      }
      if (recomendacao.operacao === 3) {
        return {
          descricao: 'Adubação Cobertura',
          tipo: 'adubacao_cobertura',
          icon: 'icon-recomendation'
        };
      }

      return {
        descricao: 'Adubação Base',
        tipo: 'adubacao_base',
        icon: 'icon-recomendation'
      };
    },
    recomendacao_semeadura: () => (
      {
        descricao: 'Recomendação de Semeadura',
        tipo: 'recomendacao_semeadura',
        icon: 'icon-recomendation'
      }
    )
  };

  const convertRecomendacaoToObject = ((recomendacao) => {
    const objectConverted = (!recomendacao || !recomendacao.id) ? {} : {
      createdAt: recomendacao.created_at,
      dataFinal: moment(recomendacao.data_final).toDate(),
      dataInicial: moment(recomendacao.data_inicial).toDate(),
      gleba: {
        descricao: recomendacao.gleba_descricao,
        id: recomendacao.gleba_id
      },
      id: recomendacao.id,
      recomendante: recomendacao.nome_recomendante,
      responsavel: recomendacao.nome_responsavel,
      tipo: tipoRecomendacao[recomendacao.tipo_pendencia](recomendacao),
      cultivar: recomendacao.cultivar,
      status: recomendacao.status,
      recomendacaoSemeaduraId: recomendacao.recomendacao_semeadura_id
    };

    return objectConverted;
  });

  const conversoes = {
    tarefa: (pendencia) => TarefaObjectService.convertToObject(pendencia),
    recomendacao_defensivo: convertRecomendacaoToObject,
    aqila_recomendacao: convertRecomendacaoToObject,
    recomendacao_semeadura: convertRecomendacaoToObject
  };

  const convertPendenciaToObject = (pendencia) => {
    const pendenciaObject = conversoes[pendencia.tipo_pendencia](pendencia);
    pendenciaObject.tipoPendencia = pendencia.tipo_pendencia;
    return pendenciaObject;
  };

  const getPendenciasFromGleba = (gleba) => gleba.pendencias.map(convertPendenciaToObject);

  const pendenciasPorGleba = ({
    propriedade = null,
    safra = null,
    gleba = null
  }) => {
    const deferred = $q.defer();

    $http.get(`${SERVER + API_VERSION}pendencias`, {
      params: { propriedade, safra, gleba }
    }).then(function(response) {
      const object = response.data.map((result) => {
        result.pendencias = getPendenciasFromGleba(result);
        return result;
      });

      deferred.resolve(object);
    }, deferred.reject);

    return deferred.promise;
  };

  return {
    pendenciasPorGleba
  };
});
